import React, { useEffect } from 'react';
import PatientQueue from '../patientQueue/patientQueue';
import './tvDisplay.scss';

const TvDisplay = () => {
  const doctorId = '2';
  const clinicId = '2';

  useEffect(() => {
    const breadcrumb = document.getElementById('breadcrumb_id');
    const header = document.getElementById('header_id');
    const footer = document.getElementById('footer_id');

    // Store previous display values to restore on unmount
    const prevBreadcrumbDisplay = breadcrumb?.style.display;
    const prevHeaderDisplay = header?.style.display;
    const prevFooterDisplay = footer?.style.display;

    if (breadcrumb) breadcrumb.style.display = 'none';
    if (header) header.style.display = 'none';
    if (footer) footer.style.display = 'none';

    return () => {
      if (breadcrumb) breadcrumb.style.display = prevBreadcrumbDisplay || '';
      if (header) header.style.display = prevHeaderDisplay || '';
      if (footer) footer.style.display = prevFooterDisplay || '';
    };
  }, []);

  return (
    <div className="tv-display-container">
      <PatientQueue doctorId={doctorId} clinicId={clinicId} />
    </div>
  );
};

export default TvDisplay;
